// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {};

export const adminQuizSlice = createSlice({
  name: 'adminQuiz',
  initialState,
  reducers: {},
});

export const {} = adminQuizSlice.actions;

export default adminQuizSlice.reducer;
